/* istanbul ignore file */
/* tslint:disable */
 
import type { AppLocaleFull } from '../models/AppLocaleFull';
import type { AvailableLocalesResponse } from '../models/AvailableLocalesResponse';
import type { PaginatedAppLocaleFullList } from '../models/PaginatedAppLocaleFullList';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class LocaleService {

  /**
   * @param page A page number within the paginated result set.
   * @param pageSize Number of results to return per page.
   * @returns PaginatedAppLocaleFullList 
   * @throws ApiError
   */
  public static localeList(
page?: number,
pageSize?: number,
): CancelablePromise<PaginatedAppLocaleFullList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/locale/',
      query: {
        'page': page,
        'page_size': pageSize,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns AppLocaleFull 
   * @throws ApiError
   */
  public static localeCreate(
requestBody: AppLocaleFull,
): CancelablePromise<AppLocaleFull> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/locale/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param id 
   * @returns AppLocaleFull 
   * @throws ApiError
   */
  public static localeRetrieve(
id: string,
): CancelablePromise<AppLocaleFull> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/locale/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns AppLocaleFull 
   * @throws ApiError
   */
  public static localeUpdate(
id: string,
requestBody: AppLocaleFull,
): CancelablePromise<AppLocaleFull> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/locale/{id}/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param id 
   * @returns void 
   * @throws ApiError
   */
  public static localeDestroy(
id: string,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/locale/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns AvailableLocalesResponse 
   * @throws ApiError
   */
  public static localeAvailableRetrieve(): CancelablePromise<AvailableLocalesResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/locale/available/',
    });
  }

}
